import React from "react";
import { NotificationManager } from "react-notifications";
import * as dev_constants from '../constants/dev_constants';
import {
  // ACTION_ADD_DEVICE,
  // ACTION_DELETE_DEVICE,
  // ACTION_UPDATE_DEVICE,
  // ACTION_BROADCAST_DEVICE_ADDED,
  // ACTION_BROADCAST_DEVICE_DELETED,
  // ACTION_BROADCAST_DEVICE_UPDATED
  ACTION_UPDATE_DEVICE_MAP,
  ACTION_UPDATE_DEVICECOUNT_OBJ
} from "../actions/device.action";

const initialState = {
  devices : new Map(),
  deviceCountObj : {
    slcCnt: 0,
    slcOnCnt: 0,
    slcOffCnt: 0,
    slcErrCnt: 0,
    lmpCnt: 0,
    lmpOnCnt: 0,
    lmpOffCnt: 0,
    modes: {
      autoCnt: 0,
      manCnt: 0,
      bypCnt: 0
    },
    inpFaults: {
      lvCnt: 0,
      hvCnt: 0,
      pfCnt: 0,
      isofCnt: 0
    },
    outFaults: {
      tripCnt: 0,
      hcCnt: 0,
      cfCnt: 0
    },
    othFaults: {
      emfCnt: 0,
      doCnt: 0,
      lbCnt: 0,
      inaCnt: 0
    },
    errGrpCounts: Array(dev_constants.EventGrpMax).fill(0),
  }
};

export default function deviceReducer(state = initialState, action) {
  console.log(`================== deviceReducer ============ action=${JSON.stringify(action)} | state=${JSON.stringify(state)}`);
  switch (action.type) {
    case ACTION_UPDATE_DEVICE_MAP: {
      const { payload } = action;
      return {
        ...state,
        devices : payload
      };
    }
    case ACTION_UPDATE_DEVICECOUNT_OBJ: {
      const { payload } = action;
      return {
        ...state,
        deviceCountObj : payload
      };
    }
  }
  return state;
}
